const getReferrerParam = () => {
  const params = new URL(window.location.href).searchParams;
  return params.get('referrer');
};

export const getReferrer = (): string =>
  document.referrer || getReferrerParam();

export const getCurrentUrl = (): string => window.location.href;
